import { Check } from 'lucide-react';
import styles from './DropdownMenu.module.scss';

export type DropdownItemSelectionMode = 'single' | 'multi';

type DropdownItemProps = {
    label: string;
    value: string;
    onClick: (value: string | number) => void;
    isSelected: boolean;
    /** `multi` uses checkbox semantics for accessibility. */
    selectionMode?: DropdownItemSelectionMode;
};

export const DropdownItem = ({ label, value, onClick, isSelected, selectionMode = 'single' }: DropdownItemProps) => {
    const isMulti = selectionMode === 'multi';

    return (
        <div
            className={styles.menuItem}
            onClick={() => onClick(value)}
            role={isMulti ? 'menuitemcheckbox' : 'menuitem'}
            aria-checked={isMulti ? isSelected : undefined}
            data-value={value}
        >
            {isSelected ? <Check size={16} color='var(--primary-purple)' /> : <span />} {label}
        </div>
    );
};
